import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { Dimensions, StyleSheet, View, Text } from "react-native";
import MaterialTabs from "react-native-material-tabs";
import { RFValue } from "react-native-responsive-fontsize";
import CustomHeader from "../../components/CustomHeader";
import MenuIcon from "../../components/icons/MenuIcon";
import Notarize from "../../components/table/Notarize";
import POI from "../../components/table/POI";
import getNotarizeResults from "../../networking/api/verification/getNotarizeResults";
import getPoiResults from "../../networking/api/verification/getPoiResults";
import state from "../../store/Store";
import BottomSheet from "reanimated-bottom-sheet";
import RejectionReason from "../../components/notarize/RejectionReason";
import Modal from "modal-enhanced-react-native-web";
import CloseIcon from "../../components/icons/CloseIcon";
import { navigate } from "../../routes/Global";

const { height, width } = Dimensions.get("window");

const Verification = observer(({ navigation }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [poiData, setPoiData] = useState([]);
  const [key, setKey] = useState();
  const [notarizeData, setNotarizeData] = useState([]);
  const [notarizeLoading, setNotarizeLoading] = useState(false);
  const [poiLoading, setPoiLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const { uid } = state;

  useEffect(() => {
    getPoiResults(
      uid,
      (e) => setPoiData(e),
      (e) => setPoiLoading(e)
    );
  }, [uid]);

  useEffect(() => {
    getNotarizeResults(
      uid,
      (e) => setNotarizeData(e),
      (e) => setNotarizeLoading(e)
    );
  }, [uid]);

  const tabs = ["POI", "Notarize"];
  const disputeRef = useRef();
  return (
    <View style={styles.container}>
      <CustomHeader title="Verification" leftIcon={<MenuIcon navigation={navigation} />} />
      <MaterialTabs
        items={tabs}
        allowFontScaling={true}
        selectedIndex={selectedTab}
        onChange={setSelectedTab}
        barColor="#181d21"
        indicatorColor="#EDD08B"
        activeTextColor="white"
        textStyle={styles.textStyle}
      />
      {selectedTab === 0 ? (
        <POI data={poiData} loading={poiLoading} />
      ) : (
        <Notarize data={notarizeData} loading={notarizeLoading} setKey={(e) => setKey(e)} setOpen={(e) => setOpen(e)} />
      )}
      <Modal visible={open} animationType="slide" transparent={false}>
        <CustomHeader title="Rejection Reason" leftIcon={<CloseIcon onPress={() => setOpen(false)} />} />
        <RejectionReason setOpen={(e) => setOpen(e)} userRef={key} open={open} />
      </Modal>
    </View>
  );
});

export default Verification;

const styles = StyleSheet.create({
  approved: { color: "white", fontSize: RFValue(11), fontFamily: "avenir" },
  container: { flex: 1 },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
